export default "__VITE_ASSET__BdMdU4Nz__"